import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import mvEasyImg from '../../assets/mv_easy.svg';
import messages from './messages';

const styles = {
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
    py: 9,
  },
  description: {
    fontSize: '16px',
  },
  image: {
    display: {
      md: 'block',
      xs: 'none',
    },
    pr: {
      md: 4,
      xs: 0,
    },
  },
  root: {
    backgroundColor: 'common.white',
    width: '100%',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'medium',
    mb: 3,
  },
  wrapper: {
    maxWidth: '1050px',
    mx: 'auto',
    width: '100%',
  },
};

const AllYouNeed = forwardRef((_, ref) => (
  <Box ref={ref} sx={styles.root}>
    <Box sx={styles.wrapper}>
      <Box sx={styles.content}>
        <Box sx={styles.image}>
          <img alt="All You Need Is an Intercom and a Mobile Phone" src={mvEasyImg} />
        </Box>
        <Box>
          <Typography component="h3" sx={styles.title}>
            <FormattedMessage {...messages.mvideoAllYouNeedTitle} />
          </Typography>
          <Typography paragraph sx={styles.description}>
            <FormattedMessage
              {...messages.mvideoAllYouNeedDescription}
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
                sup: (chunks) => <sup>{chunks}</sup>,
              }}
            />
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
));

export default AllYouNeed;
